import React from 'react';

import { ConfirmDialogUI } from '../Interface';

export const defaultBulkUpdateDialogState = {
  open: false,
  title: '',
  message: '',
  confirmButtonText: 'Sorok modoszitasa',
  value: null,
  fieldPaths: [],
  updates: [],
  setFieldValue: null,
  validateField: null,
};

const BulkUpdateFieldDialog = ({ dialogState, setDialogState }) => {
  const handleClose = () => {
    setDialogState(defaultBulkUpdateDialogState);
  };

  const handleConfirm = async () => {
    const { fieldPaths = [], updates = [], setFieldValue, validateField, value } = dialogState;

    const normalizedUpdates =
      updates.length > 0 ? updates : fieldPaths.map((fieldPath) => ({ fieldPath, value, validatePath: fieldPath }));

    if (typeof setFieldValue !== 'function' || normalizedUpdates.length === 0) {
      handleClose();
      return;
    }

    for (const update of normalizedUpdates) {
      await setFieldValue(update.fieldPath, update.value);
    }

    if (typeof validateField === 'function') {
      const validationPaths = [
        ...new Set(
          normalizedUpdates
            .map((update) => update.validatePath ?? update.fieldPath)
            .filter((fieldPath) => typeof fieldPath === 'string' && fieldPath.length > 0)
        ),
      ];

      for (const fieldPath of validationPaths) {
        await validateField(fieldPath);
      }
    }

    handleClose();
  };

  return (
    <ConfirmDialogUI
      show={dialogState.open}
      onHide={handleClose}
      handleChangeElement={handleConfirm}
      title={dialogState.title || 'Tomeges modositas'}
      message={dialogState.message || 'Frissitsuk a kapcsolodo sorokat is?'}
      confirmButtonText={dialogState.confirmButtonText}
      disabled={!dialogState.fieldPaths?.length && !dialogState.updates?.length}
      maxWidth="sm"
    />
  );
};

export default BulkUpdateFieldDialog;
